function __loadable_isReady__(self, props) {
  if (typeof __webpack_modules__ !== "undefined") {
    return !!__webpack_modules__[self.resolve(props)];
  }
  
  return false;
}
function __loadable_requireSync__(self, props) {
  var id = self.resolve(props);
  if (typeof __webpack_require__ !== 'undefined') {
    return __webpack_require__(id);
  }
  return eval('module.require')(id);
}
import React, { useEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import loadable from '@loadable/component';
import toTop from '../../Utils/toTop';
import NotFound from '../404/NotFound';
import IdentityRouter from './IdentityRouter/IdentityRouter';
import QuizPage from '../QuizPage/QuizPage';
import LoginPage from '../LoginPage/LoginPage';
import ChavesRouter from './ChavesRouter/ChavesRouter';
import Identity from '../Identity/Identity';
import NotAllowed from '../403/NotAllowed';
import Hexpass from '../Hexpass/Hexpass';
import HexpassTable from '../HexpassTable/HexpassTable';
import Dashboard from '../Dashboard/Dashboard';
import Comandante from '../../Proto/Comandante/Comandante';
import Realizador from '../../Proto/Realizador/Realizador';
import Mediador from '../../Proto/Mediador/Mediador';
import Prestativo from '../../Proto/Prestativo/Prestativo';
import Visionario from '../../Proto/Visionario/Visionario';
import Organizador from '../../Proto/Organizador/Organizador';
import Analitico from '../../Proto/Analitico/Analitico';
import Planejador from '../../Proto/Planejador/Planejador';
import Criativo from '../../Proto/Criativo/Criativo';
const ClientRouter = loadable({
    chunkName() {
        return "ClientRouter-ClientRouter";
    },
    isReady(props) {
        return __loadable_isReady__(this, props);
    },
    requireAsync: () => import(/* webpackChunkName: "ClientRouter-ClientRouter" */ './ClientRouter/ClientRouter'),
    requireSync(props) {
        return __loadable_requireSync__(this, props);
    },
    resolve() {
        return require.resolveWeak ? require.resolveWeak(/* webpackChunkName: "ClientRouter-ClientRouter" */ './ClientRouter/ClientRouter') : eval("require.resolve")(/* webpackChunkName: "ClientRouter-ClientRouter" */ './ClientRouter/ClientRouter');
    }
});
const MainRouter = () => {
    const location = useLocation();
    useEffect(() => {
        toTop();
    }, [location]);
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: "/", component: Identity }),
        React.createElement(Route, { exact: true, path: "/404", component: NotFound }),
        React.createElement(Route, { exact: true, path: "/403", component: NotAllowed }),
        React.createElement(Route, { path: "/cliente", component: ClientRouter }),
        React.createElement(Route, { path: "/quiz", component: QuizPage }),
        React.createElement(Route, { path: "/login", component: LoginPage }),
        React.createElement(Route, { path: "/identity", component: IdentityRouter }),
        React.createElement(Route, { path: "/Hexpass", component: Hexpass }),
        React.createElement(Route, { path: "/dashboard", component: Dashboard }),
        React.createElement(Route, { path: "/HexpassTable", component: HexpassTable }),
        React.createElement(Route, { path: "/comandante", component: Comandante }),
        React.createElement(Route, { path: "/realizador", component: Realizador }),
        React.createElement(Route, { path: "/mediador", component: Mediador }),
        React.createElement(Route, { path: "/prestativo", component: Prestativo }),
        React.createElement(Route, { path: "/visionario", component: Visionario }),
        React.createElement(Route, { path: "/analitico", component: Analitico }),
        React.createElement(Route, { path: "/criativo", component: Criativo }),
        React.createElement(Route, { path: "/organizador", component: Organizador }),
        React.createElement(Route, { path: "/planejador", component: Planejador }),
        React.createElement(Route, { path: "/chaves", component: ChavesRouter }),
        React.createElement(Route, { component: NotFound })));
};
MainRouter.displayName = 'MainRouter';
export default MainRouter;
